/**
 * Category lists. They live in one place, shared/categories/categories.json,
 * and are derived by shared/categories/index.js. Never add a category here:
 * edit the master file. Spec: docs/specs_20260924_category_master_list.md.
 */
export {
  CATEGORY_GROUPS,
  CATEGORY_GROUP_ORDER,
  PRODUCT_TYPES,
  SUBS_BY_MAIN,
  getMainCategories,
  PAIRABLE_SUBS,
} from '../../../shared/categories/index.js'


/**
 * Search utilities
 */
export const getSearchTerm = (title) => {
  if (!title) return ''
  const dashIndex = title.indexOf(' - ')
  return dashIndex > 0 ? title.substring(0, dashIndex) : title
}

export const getSearchUrls = (title) => {
  const term = encodeURIComponent(getSearchTerm(title))
  return {
    reverbSold: `https://reverb.com/uk/marketplace?query=${term}&show_only_sold=true`,
    ebayActive: `https://www.ebay.co.uk/sch/i.html?_nkw=${term}&_sacat=0&LH_BIN=1&_dmd=2&rt=nc`,
    ebaySold: `https://www.ebay.co.uk/sch/i.html?_nkw=${term}&_sacat=0&LH_Complete=1&LH_Sold=1&rt=nc&LH_BIN=1&_dmd=2&rt=nc`,
    // UK Google Shopping (tbm=shop, gl=GB, hl=en) — UK results regardless of operator location.
    google: `https://www.google.com/search?tbm=shop&q=${term}&gl=GB&hl=en`
  }
}

export const openSearchWindow = (url) => {
  window.open(url, '_blank', 'width=1200,height=800')
}

export const SHOPIFY_ADMIN_URL = 'https://admin.shopify.com/store/143c34'
